"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _Accordion = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Accordion");

var _Accordion2 = _interopRequireDefault(_Accordion);

var _TextInput = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/TextInput");

var _TextInput2 = _interopRequireDefault(_TextInput);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _polyfluid = require("@quixeltools/quixel-ui-library/dist/utils/polyfluid");

var _fonts = require("@quixeltools/quixel-ui-library/dist/utils/fonts");

var _components = require("components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var footer = (0, _glamor.css)({
  color: _css.colors.white,
  background: _css.colors.medGray,
  padding: (0, _css.unitRem)(4) + " 0 " + (0, _css.unitRem)(2) + " 0"
}, (0, _css.minWidth)(_css.breakpoints.medium)({
  padding: (0, _css.unitRem)(4) + " 0"
}), (0, _polyfluid.polyfluid)({
  paddingTop: {
    smallMedium: [3.375, 4.5],
    mediumLarge: [4.5, 6]
  },
  paddingBottom: {
    smallMedium: [1.6875, 2.25],
    mediumLarge: [2.25, 3]
  }
}), (0, _css.maxWidth)(_css.breakpoints.medium)({
  paddingBottom: "0px"
}));

var footerInner = (0, _glamor.css)({
  margin: "auto",
  paddingLeft: "1.5em",
  paddingRight: "1.5em",
  maxWidth: "75%"
}, (0, _css.minWidth)(_css.breakpoints.xlarge)({
  paddingLeft: 0,
  paddingRight: 0
}), (0, _css.maxWidth)(_css.breakpoints.medium)({
  paddingLeft: "0px",
  paddingRight: "0px"
}));

var secondRow = (0, _glamor.css)({
  position: "relative",
  textAlign: "center",
  marginTop: "2.6vw",
  marginBottom: "4.9vw"
}, (0, _css.maxWidth)(_css.breakpoints.medium)({
  justifyContent: "center",
  paddingTop: "2rem",
  paddingBottom: "2rem"
}));
var subscribeColumn = (0, _glamor.css)(_fonts.footersubscribeColumn, {
  width: "50%",
  "& h2": (0, _glamor.css)({
    letterSpacing: "-1.2px",
    textAlign: "center",
    margin: 0,
    marginBottom: "" + (0, _css.unitRem)(1.4)
  }, (0, _css.minWidth)(_css.breakpoints.medium)({
    textAlign: "left"
  }))
}, (0, _css.maxWidth)(_css.breakpoints.xxlarge)({
  flexBasis: "62%"
}), (0, _css.maxWidth)(_css.breakpoints.medium)({
  flexBasis: "100%"
}));

var linksColumn = (0, _glamor.css)(_fonts.footerLinksColumn, {
  flexBasis: "25%",
  color: _css.colors.white,
  "& h2": (0, _glamor.css)({
    margin: "0 0 2em 0"
  }),
  "& ul": (0, _glamor.css)(_css.noListStyle, {
    "& li": (0, _glamor.css)({
      margin: (0, _css.unitRem)(0.5) + " 0"
    }, (0, _polyfluid.polyfluid)({
      marginTop: {
        smallMedium: 0.5625,
        mediumLarge: [0.5625, 0.75]
      },
      marginBottom: {
        smallMedium: 0.5625,
        mediumLarge: [0.5625, 0.75]
      }
    }))
  })
}, (0, _css.maxWidth)(_css.breakpoints.medium)({
  display: "none"
}));

var logoWrap = (0, _glamor.css)({
  marginBottom: "3em",
  float: "left"
}, (0, _css.minWidth)(_css.breakpoints.medium)({
  marginBottom: 0
}), (0, _css.maxWidth)(_css.breakpoints.medium)({
  marginBottom: "1em",
  float: "none"
}));

var logo = (0, _glamor.css)({
  maxWidth: (0, _css.unitRem)(4.85),
  width: "40px",
  height: "40px",
  marginLeft: "-3px",
  opacity: 0.3
});

var smallLinks = (0, _glamor.css)(_css.noListStyle, {
  color: _css.colors.gray,
  marginBottom: "3em",
  margin: "10px 30px",
  float: "left",
  "& li": {
    display: "inline-block",
    marginRight: (0, _css.unitRem)(0.65),

    "& a": {
      ":hover": {
        color: _css.colors.white
      }
    },
    "::after": {
      content: '"|"',
      color: "inherit",
      display: "inline-block",
      marginLeft: (0, _css.unitRem)(0.65)
    },
    "&:last-child": {
      marginRight: "0",

      "::after": {
        content: '""',
        marginLeft: "0"
      }
    }
  }
}, (0, _css.minWidth)(_css.breakpoints.medium)({
  marginBottom: 0
}), (0, _css.maxWidth)(_css.breakpoints.medium)({
  float: "none",
  margin: "30px 0px"
}));

var copyright = (0, _glamor.css)(_fonts.p5, {
  // textTransform: "uppercase",
  color: _css.colors.gray,
  flexBasis: "25%",
  float: "right",
  marginTop: "38px",
  width: "100%"
}, (0, _css.maxWidth)(_css.breakpoints.medium)({
  float: "none"
}));

var columnsStyle = function columnsStyle(isFull) {
  return (0, _glamor.css)({
    display: isFull ? "flex" : "none",
    justifyContent: "space-between"
  }, (0, _css.maxWidth)("100em")({
    display: isFull ? "none" : "flex"
  }), (0, _css.maxWidth)(_css.breakpoints.medium)({
    paddingLeft: "1.5em",
    paddingRight: "1.5em"
  }));
};

var smallLinksColumnsStyle = (0, _glamor.css)((0, _css.minWidth)(_css.breakpoints.medium)({
  alignItems: "center",
  height: "22px"
}));

var siteLinks = (0, _glamor.css)({
  width: "50%",
  margin: "24px 0px !important"
}, (0, _css.maxWidth)(_css.breakpoints.xxlarge)({
  margin: "18px 0px !important"
}), (0, _css.maxWidth)(_css.breakpoints.medium)({
  margin: "17px 0px !important"
}));

var linkStyle = (0, _glamor.css)({
  paddingLeft: 0,
  paddingRight: 0,
  paddingTop: "0.2em",
  paddingBottom: "0.2em",
  textTransform: "initial",
  whiteSpace: "nowrap"
});

// const subscribeColumn = css({
//   width: '50%',
//   '& h2': css({
//     fontWeight: 700,
//     textAlign: 'center',
//     margin: 0,
//     marginBottom: `${unitRem(1.4)}`,
//   }, polyfluid({
//     fontSize: {
//       small: [2, 2.25],
//       medium: 2.25,
//     },
//   }), minWidth(breakpoints.medium)({
//     textAlign: 'left',
//   }, polyfluid({
//     fontSize: {
//       medium: 1.25,
//       large: [1.25, 1.5],
//     },
//   }))),
// }, maxWidth(breakpoints.xxlarge)({
//   flexBasis: '62%',
// }), maxWidth(breakpoints.medium)({
//   flexBasis: '100%',
// }))

var subscribeForm = (0, _glamor.css)({
  margin: "auto",
  "& form": {
    display: "flex",
    justifyContent: "flex-start",
    alignItem: "center"
  }
}, (0, _css.maxWidth)(_css.breakpoints.medium)({
  maxWidth: "auto",
  "& form": {
    flexDirection: "column"
  }
}));
var textInputStyles = (0, _glamor.css)({
  width: "100%",
  margin: "auto",
  marginLeft: 0,
  maringRight: "2em",
  maxWidth: "454px"
}, (0, _css.minWidth)(_css.breakpoints.xlarge)({
  margin: "unset"
}), (0, _css.maxWidth)(_css.breakpoints.medium)({
  width: "80%",
  marginBottom: "2em",
  marginLeft: "auto",
  maringRight: "auto"
}));

var subscribe = (0, _glamor.css)({
  display: "block",
  width: "auto",
  textAlign: "center",
  "& button": {
    paddingTop: "1.1em",
    paddingBottom: "1.1em",
    maxWidth: "160px"
  }
}, (0, _css.maxWidth)(_css.breakpoints.medium)({
  "& button": {
    padding: "1.1em 0",
    minWidth: "210px!important"
  },
  "& a": {
    minWidth: "210px!important"
  }
}), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  "& button": {
    padding: "1.1em 0",
    minWidth: "100%",
    maxWidth: "100%",
    width: "100%"
  },
  "& a": {
    minWidth: "100%",
    maxWidth: "100%",
    width: "100%"
  }
}), (0, _css.minWidth)(_css.breakpoints.medium)({
  width: (0, _css.unitRem)(4.75),
  textAlign: "left",
  marginLeft: "25px",
  marginRight: 0
}));

var companyImages = (0, _glamor.css)({
  width: "100%",
  textAlign: "center",
  marginTop: "2.6vw",
  "& img": {
    maxWidth: "8.33%",
    maxHeight: "8.33%"
  }
}, (0, _css.maxWidth)("100em")({
  "& img": {
    maxWidth: "16.33%",
    maxHeight: "16.33%"
  }
}));

var emailInput = (0, _glamor.css)({
  background: "#181818",
  borderColor: "#181818"
});

var socialLinks = (0, _glamor.css)({
  whiteSpace: "nowrap",
  display: "flex",
  flexWrap: "wrap",
  marginLeft: "-18px"
}, (0, _css.maxWidth)(_css.breakpoints.medium)({
  justifyContent: "center"
}));

var socialLink = (0, _glamor.css)({
  display: "inline",
  opacity: 0.2,
  transition: "opacity 0.25s",
  margin: "2em 1em 0em",
  "& img": {
    width: "40px"
  },
  "&:hover": {
    opacity: 0.7
  },
  "&:last-child": {
    marginRight: "0px"
  }
}, (0, _css.minWidth)(_css.breakpoints.xxlarge)({
  "& img": {
    width: "40px"
  }
}));

var _copyright = (0, _glamor.css)({
  textAlign: "center",
  paddingTop: "50px",
  paddingBottom: "50px"
}, (0, _css.minWidth)(_css.breakpoints.medium)({
  display: "none"
}));

var hr = (0, _glamor.css)({
  opacity: "0.1",
  marginTop: "2.6vw"
}, (0, _css.maxWidth)(_css.breakpoints.medium)({
  display: "none"
}));

var title = (0, _glamor.css)({
  fontSize: "1.25rem",
  fontWeight: 700,
  letterSpacing: "-1.2px"
});

var dropdownLinks = (0, _glamor.css)({
  marginTop: (0, _css.unitRem)(2),
  marginBottom: (0, _css.unitRem)(2)
}, (0, _css.minWidth)(_css.breakpoints.medium)({
  display: "none"
}));

var ul = (0, _glamor.css)({
  marginLeft: "2.6rem"
});
var successMessage = (0, _glamor.css)({
  color: "#95d34c",
  marginTop: "12px",
  marginLeft: "2px"
}, (0, _css.maxWidth)(_css.breakpoints.mediumSmall)({
  textAlign: "center"
}));
var lengthLessThanOrEqualToFour = _ramda2.default.compose(_ramda2.default.gte(5), _ramda2.default.prop("length"));
var lengthEqualToThree = _ramda2.default.propEq("length", 3);

var LinksColumn = function (_React$Component) {
  (0, _inherits3.default)(LinksColumn, _React$Component);

  function LinksColumn(props) {
    (0, _classCallCheck3.default)(this, LinksColumn);
    return (0, _possibleConstructorReturn3.default)(this, (LinksColumn.__proto__ || (0, _getPrototypeOf2.default)(LinksColumn)).call(this, props));
  }

  (0, _createClass3.default)(LinksColumn, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return _react2.default.createElement(
        "div",
        linksColumn,
        _react2.default.createElement(
          "h2",
          null,
          props.title
        ),
        _react2.default.createElement(
          "ul",
          null,
          props.links.map(function (link) {
            return _react2.default.createElement(
              "li",
              { className: siteLinks, key: link.label },
              link.href.startsWith("/") ? _react2.default.createElement(_components.TextButtonLibrary, {
                className: linkStyle,
                mode: "gray",
                label: link.label,
                to: link.href,
                onClick: link.onClick
              }) : _react2.default.createElement(_components.TextButtonLibrary, {
                className: linkStyle,
                mode: "gray",
                label: link.label,
                href: link.href,
                newWindow: link.newWindow
              })
            );
          })
        )
      );
    }
  }]);
  return LinksColumn;
}(_react2.default.Component);

var SubscriptionColumn = function (_React$Component2) {
  (0, _inherits3.default)(SubscriptionColumn, _React$Component2);

  function SubscriptionColumn(props) {
    (0, _classCallCheck3.default)(this, SubscriptionColumn);
    return (0, _possibleConstructorReturn3.default)(this, (SubscriptionColumn.__proto__ || (0, _getPrototypeOf2.default)(SubscriptionColumn)).call(this, props));
  }

  (0, _createClass3.default)(SubscriptionColumn, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return _react2.default.createElement(
        "div",
        { className: subscribeColumn },
        _react2.default.createElement(
          "h2",
          null,
          props.title
        ),
        _react2.default.createElement(
          "div",
          { className: subscribeForm },
          _react2.default.createElement(
            "form",
            null,
            _react2.default.createElement(_TextInput2.default, {
              label: "",
              placeholder: "Join our mailing list",
              type: "email",
              value: props.subscriberEmail,
              onChange: props.onChange,
              name: "EMAIL",
              inputClassName: emailInput,
              className: textInputStyles
            }),
            _react2.default.createElement(_Button2.default, {
              type: "button",
              label: "Join Now",
              mode: "secondary",
              className: subscribe,
              onClick: props.onClickHandler
            })
          )
        ),
        props.subscribed && _react2.default.createElement(
          "div",
          { className: successMessage },
          "You are subscribed successfully"
        ),
        props.socialLinks && props.socialLinks.length && _react2.default.createElement(
          "ul",
          { className: socialLinks },
          props.socialLinks.filter(function (link) {
            return link.icon;
          }).map(function (link) {
            return _react2.default.createElement(
              "li",
              { className: socialLink, key: link.icon },
              _react2.default.createElement(
                "a",
                { href: link.href, target: "_blank", rel: "noreferrer" },
                _react2.default.createElement("img", { src: "/icons/social/" + link.icon })
              )
            );
          })
        )
      );
    }
  }]);
  return SubscriptionColumn;
}(_react2.default.Component);

var footerText = (0, _glamor.css)(_fonts.p5, {
  textTransform: "uppercase",
  "& a": {
    fontWeight: 400
  }
});

var SiteFooter = function (_React$Component3) {
  (0, _inherits3.default)(SiteFooter, _React$Component3);

  function SiteFooter(props) {
    (0, _classCallCheck3.default)(this, SiteFooter);
    return (0, _possibleConstructorReturn3.default)(this, (SiteFooter.__proto__ || (0, _getPrototypeOf2.default)(SiteFooter)).call(this, props));
  }

  (0, _createClass3.default)(SiteFooter, [{
    key: "render",
    value: function render() {
      var props = this.props;

      var linkRows = [];
      var fullRows = [];
      var linkCols = [];
      for (var i = 0; i < props.columns.length; i++) {
        if (i == 3) {
          linkRows.push(linkCols);
          linkRows.push([_react2.default.createElement("div", { key: i, style: { width: "100%", height: "2vw" } })]);
          linkCols = [];
        }
        var column = _react2.default.createElement(LinksColumn, (0, _extends3.default)({}, props.columns[i], { key: props.columns[i].title }));

        linkCols.push(column);
        fullRows.push(column);
      }

      fullRows.push(_react2.default.createElement(SubscriptionColumn, {
        key: "fullRows-SubscriptionColumn",
        title: "Connect",
        subscriberEmail: props.subscriberEmail,
        subscribeLink: props.subscribeLink,
        onClickHandler: props.onClickHandler,
        onChange: props.onChange,
        socialLinks: props.socialLinks ? props.socialLinks : null,
        subscribed: props.subscribed
      }));

      linkCols.push(_react2.default.createElement(SubscriptionColumn, {
        key: "linkCols-SubscriptionColumn",
        title: "Connect",
        subscriberEmail: props.subscriberEmail,
        subscribeLink: props.subscribeLink,
        onClickHandler: props.onClickHandler,
        onChange: props.onChange,
        socialLinks: props.socialLinks ? props.socialLinks : null,
        subscribed: props.subscribed
      }));

      linkRows.push(linkCols);

      return _react2.default.createElement(
        "footer",
        { className: footer },
        _react2.default.createElement(
          "div",
          { className: footerInner },
          linkRows.map(function (row, i) {
            return _react2.default.createElement(
              "div",
              {
                key: i
                /* @TODO Use better value */, className: columnsStyle(false)
              },
              row
            );
          }),
          _react2.default.createElement(
            "div",
            { className: columnsStyle(true) },
            fullRows
          ),
          _react2.default.createElement(
            "div",
            { className: dropdownLinks },
            _react2.default.createElement(
              _Accordion2.default,
              { initialClosed: true },
              props.columns.map(function (col) {
                return [_react2.default.createElement(
                  _Accordion2.default.Title,
                  { key: col.title },
                  _react2.default.createElement(
                    "span",
                    { className: title },
                    col.title
                  )
                ), _react2.default.createElement(
                  _Accordion2.default.Content,
                  null,
                  _react2.default.createElement(
                    "ul",
                    { className: ul },
                    col.links.map(function (link, key) {
                      return _react2.default.createElement(
                        "li",
                        (0, _defineProperty3.default)({ key: key, className: siteLinks }, "key", link.label),
                        link.href.startsWith("/") ? _react2.default.createElement(_components.TextButtonLibrary, {
                          className: linkStyle,
                          mode: "gray",
                          label: link.label,
                          to: link.href,
                          onClick: link.onClick
                        }) : _react2.default.createElement(_components.TextButtonLibrary, {
                          className: linkStyle,
                          mode: "gray",
                          label: link.label,
                          href: link.href,
                          newWindow: link.newWindow
                        })
                      );
                    })
                  )
                )];
              })
            )
          ),
          _react2.default.createElement("hr", { className: hr }),
          _react2.default.createElement(
            "div",
            { className: companyImages },
            props.clients.map(function (logo) {
              return _react2.default.createElement("img", { key: logo, src: logo });
            })
          ),
          _react2.default.createElement("hr", { className: hr }),
          _react2.default.createElement(
            "div",
            { className: secondRow },
            _react2.default.createElement(
              "div",
              { className: smallLinksColumnsStyle },
              _react2.default.createElement(
                "div",
                { className: logoWrap },
                _react2.default.createElement("img", { className: logo, src: props.logoSrc, alt: props.logoAlt })
              ),
              _react2.default.createElement(
                "ul",
                { className: smallLinks },
                props.smallLinks.map(function (link) {
                  return _react2.default.createElement(
                    "li",
                    { key: link.label },
                    _react2.default.createElement(_components.TextButtonLibrary, {
                      key: link.label,
                      to: link.href,
                      label: link.label,
                      mode: "small-gray",
                      className: footerText
                    })
                  );
                })
              ),
              _react2.default.createElement(
                "small",
                { className: (0, _glamor.css)({ textAlign: "left" }, copyright) },
                props.copyrights
              )
            )
          )
        )
      );
    }
  }]);
  return SiteFooter;
}(_react2.default.Component);

exports.default = SiteFooter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SiteFooterNew/component/SiteFooter.jsx
// module id = 2669
// module chunks = 0